import React from "react";
import { useForm, Controller } from "react-hook-form";
import {
  Button,
  CustomInput,
  Input,
} from "../../../Components/CustomComponents";
import Fieldset from "../../../Components/FieldSet";
import { Form, InputGroup, Row, Col } from "react-bootstrap";
import MainCard from "../../../Components/Cards/MainCard";

const PaymentGatewayIntegrationForm = () => {
  const {
    handleSubmit,
    control,
    formState: { errors, isValid, isDirty },
  } = useForm({
    defaultValues: {
      stripe_api_key: "",
      paypal_client_id: "",
      square_application_id: "",
    },
  });

  const onSubmit = (data) => {
    console.log(data);
  };

  return (
    <MainCard>
      <Form onSubmit={handleSubmit(onSubmit)} autoComplete="off">
        <Row>
          <Col lg={4} md={4} sm={12}>
            <h6>Stripe API Key</h6>
            <Controller
              name="stripe_api_key"
              control={control}
              rules={{ required: "Stripe API Key is required" }}
              render={({ field }) => (
                <InputGroup className="my-2">
                  <Input
                    {...field}
                    placeholder="Enter Stripe API Key"
                    type="password"
                    autoComplete="new-password"
                  />
                </InputGroup>
              )}
            />
          </Col>
          <Col lg={4} md={4} sm={12}>
            <h6>PayPal Client ID</h6>
            <Controller
              name="paypal_client_id"
              control={control}
              rules={{ required: "PayPal Client ID is required" }}
              render={({ field }) => (
                <InputGroup className="my-2">
                  <Input
                    {...field}
                    placeholder="Enter PayPal Client ID"
                    type="password"
                    autoComplete="new-password"
                  />
                </InputGroup>
              )}
            />
          </Col>
          <Col lg={4} md={4} sm={12}>
            <h6>Square Application ID</h6>
            <Controller
              name="square_application_id"
              control={control}
              rules={{ required: "Square Application ID is required" }}
              render={({ field }) => (
                <InputGroup className="my-2">
                  <Input
                    {...field}
                    placeholder="Enter Square Application ID"
                    type="password"
                    autoComplete="new-password"
                  />
                </InputGroup>
              )}
            />
          </Col>
        </Row>
        <div className="d-grid gap-2 d-md-flex justify-content-md-start">
          <Button
            text={"Test Connection"}
            classes={`fs-6 mb-2 mt-auto mt-3 mb-2 col-12 col-md-auto`}
            type="button"
          />
          <Button
            text={"Save Configuration"}
            classes={`fs-6 mb-2 mt-auto mt-3 mb-2 col-12 col-md-auto ${
              !isDirty ? "bg-dark-subtle" : ""
            }`}
            type="submit"
            disabled={!isDirty}
          />
        </div>
      </Form>
    </MainCard>
  );
};

export default PaymentGatewayIntegrationForm;
